import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getSaveaPhone, getSaveaPhoneTel } from '../config/phoneConfig';

export const StickyPhoneBar = ({ providerColor, providerColorHex, hideOnV2 = false, phoneOverrideTel, phoneOverrideDisplay }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  
  // Pages V2 qui ont leur propre sticky bar (inclut toutes les pages fournisseurs FR NRJ, ES NRJ, ES BOX)
  const isV2Page = 
    location.pathname.includes('/fr/fournisseur/') ||
    location.pathname.includes('/fr/fournisseurs/') ||
    location.pathname.includes('/es/proveedor/') ||
    location.pathname.includes('/es/proveedores/') ||
    location.pathname.includes('/fr/comparer-fournisseurs');
  
  // Si hideOnV2 est true et qu'on est sur une page V2, ne pas afficher
  if (hideOnV2 && isV2Page) {
    return null;
  }
  
  // Déterminer le pays et le vertical basé sur l'URL
  const isSpanish = location.pathname.startsWith('/es');
  const isInternet = location.pathname.includes('internet') || location.pathname.includes('fibra');
  
  const country = isSpanish ? 'ES' : 'FR';
  const vertical = isInternet ? 'internet' : 'electricity';
  
  // SB = Sticky Bar numéro (avec override possible)
  const saveaPhone = phoneOverrideDisplay || getSaveaPhone(country, vertical, 'SB');
  const saveaPhoneTel = phoneOverrideTel || getSaveaPhoneTel(country, vertical, 'SB');

  // Couleur par défaut ou couleur du fournisseur (classe CSS)
  const bgColor = providerColorHex ? '' : (providerColor || 'bg-emerald-600 hover:bg-emerald-700');
  
  // Style inline si couleur hex fournie
  const inlineStyle = providerColorHex ? { backgroundColor: providerColorHex } : {};

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <a 
        href={`tel:${saveaPhoneTel}`}
        className={`block w-full ${bgColor} shadow-lg py-2 px-4 transition-all hover:opacity-90`}
        style={inlineStyle}
        data-testid="sticky-phone-bar"
        {...(!phoneOverrideTel && { 'data-dest': '0564098904' })}
      >
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center gap-2">
            <Phone className="w-5 h-5 text-white" />
            <span className="text-white font-bold text-lg savea-phone-number">
              {saveaPhone}
            </span>
          </div>
          <span className="text-white/90 text-xs font-medium">
            {isSpanish ? 'Servicio Gratuito 8h - 21h' : 'Numéro Gratuit 8h - 21h'}
          </span>
        </div>
      </a>
    </div>
  );
};

export default StickyPhoneBar;
